import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../services/baseQuery';
import { extractErrorMessage } from '../../../utils/errorUtils';
import type { ApiResponse } from '../../menu/types';
import { toCamelCase } from '../utils';

export type FinanceEmailAttachment = {
  name: string;
  contentType: string;
  canView: boolean;
  available: boolean;
};

export type FinanceEmailAttachmentsResponse = {
  historyId: string;
  direction: string;
  attachments: FinanceEmailAttachment[];
};

export const FINANCE_EMAIL_ATTACHMENT_API = '/umbraco/api/FinanceEmailAttachment';

export const financeEmailApi = createApi({
  reducerPath: 'financeEmailApi',
  baseQuery,
  endpoints: (builder) => ({
    getFinanceEmailAttachments: builder.query<FinanceEmailAttachmentsResponse, string>({
      query: (historyId) => ({
        url: `${FINANCE_EMAIL_ATTACHMENT_API}/List`,
        params: { historyId },
      }),
      transformResponse: (response: ApiResponse<FinanceEmailAttachmentsResponse>) => {
        if ((response.Code ?? response.code) === 1) {
          const data = toCamelCase(response.data) as FinanceEmailAttachmentsResponse;
          return {
            ...data,
            attachments: Array.isArray(data?.attachments) ? data.attachments : [],
          };
        }

        throw new Error(extractErrorMessage(response, 'Failed to load attachments.'));
      },
    }),
  }),
});

export const { useGetFinanceEmailAttachmentsQuery } = financeEmailApi;
